import React, { useRef } from "react";
import { Drawer, Button } from "antd";
import { PrinterOutlined } from "@ant-design/icons";
import EmployeeEvaluationFormTest from "./Includes/EmployeeEvaluationFormTest";

const LoanDrawer = ({
  drawerVisibility,
  onCloseDrawer,
  selectedRecord,
  setSelectedRecord,
  userEmployeeId,
}) => {
  const printRef = useRef(null);

  const handlePrint = () => {
    const printContent = document.getElementById("print-version");
    const printWindow = window.open("", "_blank", "width=900,height=1000");
    const printoutTime = new Date().toLocaleString();
    // Remove Printout Time injection
    // printHtml = printHtml.replace(
    //   /<\/tbody>/i,
    //   `<tr><td><b>Printout Time</b></td><td colspan=\"3\">${printoutTime}</td></tr></tbody>`
    // );
    // console.log(printHtml); // Debug: check if Printout Time row is present
    printWindow.document.write(`
      <html>
        <head>
          <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/antd/4.24.12/antd.min.css" />
          <style>
            body {
              font-family: Arial, sans-serif;
              padding: 20px;
              background: white;
              color: black;
              zoom: 95%;
            }
            .ant-row, .ant-col, .ant-steps-item-title {
              color: black !important;
            }
            .drawer__content {
              background: #fff;
              padding: 24px;
              border-radius: 8px;
              box-shadow: 0 0 0.5px rgba(0,0,0,0.1);
            }
            @media print {
              @page {
                size: A4;
                margin: 5mm;
                @bottom-center {
                  content: "Page " counter(page) " of " counter(pages);
                  font-size: 12px;
                  color: #888;
                }
              }
              body {
                font-family: 'Arial', sans-serif;
                font-size: 15px;
                color: #222;
                margin: 20px;
              }
              .print-title {
                display: none !important;
              }
              .employee-info-table {
                width: 100%;
                border-collapse: collapse;
                margin-bottom: 24px;
              }
              .employee-info-table th, .employee-info-table td {
                border: 1px solid #888;
                padding: 8px 12px;
                text-align: left;
              }
              .employee-info-table th {
                background: #f0f0f0;
                font-weight: bold;
              }
              .employee-info-table tr:nth-child(even) {
                background: #fafafa;
              }
              .section-heading {
                font-size: 18px;
                font-weight: bold;
                margin: 18px 0 8px 0;
              }
              /* Hide buttons and UI controls */
              button, .ant-btn, .drawer__content .ant-btn {
                display: none !important;
              }
              /* Hide all Ant Design icons in print */
              .anticon, .anticon-exclamation-circle {
                display: none !important;
              }
            }
            /* .employee-info-table {
              display: none;
            } */
          </style>
        </head>
        <body>
          ${printContent.innerHTML}
        </body>
      </html>
    `);
    printWindow.document.close();
    setTimeout(() => {
      printWindow.print();
      printWindow.close();
    }, 500);
  };
  return (
    <Drawer
      className="approval-form-wrapper"
      title={
        selectedRecord ? " Update Evaluation Form" : "Employee Evaluation Form"
      }
      visible={drawerVisibility}
      width={800}
      maskClosable={false}
      onClose={onCloseDrawer}
      closable={false}
    >
      {/* Print Button */}
      <div style={{ marginBottom: 16, textAlign: "right" }}>
        <Button
          onClick={handlePrint}
          type="default"
          shape="circle"
          icon={<PrinterOutlined />}
          title="Print Form"
          style={{
            fontSize: 20,
            color: "#1890ff",
            border: "none",
            boxShadow: "none",
          }}
        />
      </div>

      {/* Printable Content */}
      <div ref={printRef} className="drawer__content">
        {/* Normal UI */}
        <EmployeeEvaluationFormTest
          onCloseDrawer={onCloseDrawer}
          selectedRecord={selectedRecord}
          setSelectedRecord={setSelectedRecord}
          supervisorId={userEmployeeId}
          userEmployeeId={userEmployeeId}
          isSupervisor={true}
          // Do NOT pass isPrinting here
        />
        {/* Hidden print-only version */}
        <div id="print-version" style={{ display: "none" }}>
          <EmployeeEvaluationFormTest
            onCloseDrawer={onCloseDrawer}
            selectedRecord={selectedRecord}
            setSelectedRecord={setSelectedRecord}
            supervisorId={userEmployeeId}
            userEmployeeId={userEmployeeId}
            isSupervisor={true}
            isPrinting={true}
          />
        </div>
      </div>
    </Drawer>
  );
};

export default LoanDrawer;
